const BASE_NAME = 'referral_module';

const SET_CALLBACK_REFERRAL_MODAL = `${BASE_NAME
}/SET_CALLBACK_REFERRAL_MODAL`;
const SET_REFERRAL_SHARE_MODAL = `${BASE_NAME
}/SET_REFERRAL_SHARE_MODAL`;

const initialState = {
  callBackModalState: false,
  successReferralModalState: false,
};

export function setCallbackReferralModal(modalState) {
  return {
    type: SET_CALLBACK_REFERRAL_MODAL,
    payload: modalState,
  };
}

export function setReferralSuccessShareModal(modalState) {
  return {
    type: SET_REFERRAL_SHARE_MODAL,
    payload: modalState,
  };
}

export default function callbackReferralModalReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case SET_CALLBACK_REFERRAL_MODAL: {
      return {
        ...state,
        callBackModalState: action.payload,
      };
    }
    case SET_REFERRAL_SHARE_MODAL: {
      return {
        ...state,
        successReferralModalState: action.payload,
      };
    }
    default:
      return state;
  }
}
